// src/components/post/PostAuthor.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ReactTimeAgo from 'react-time-ago';

const PostAuthor = ({ authorID, createdAt, compact = false }) => {
    const [author, setAuthor] = useState({});
    const [loading, setLoading] = useState(true);

    const authorId = typeof authorID === 'object' ? authorID._id : authorID;

    useEffect(() => {
        const getAuthor = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/${authorID}`);
                setAuthor(response?.data);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        
        if (authorID) {
            getAuthor();
        }
    }, [authorID]);

    if (loading) {
        return (
            <div className="flex items-center animate-pulse">
                <div className="w-10 h-10 bg-gray-200 rounded-full mr-3"></div>
                <div className="flex-1">
                    <div className="h-3 bg-gray-200 rounded w-24 mb-2"></div>
                    <div className="h-2 bg-gray-200 rounded w-16"></div>
                </div>
            </div>
        );
    }

    // Compact version for cards
    if (compact) {
        return (
            <Link to={`/profile/${authorID}`} className="flex items-center">
                <div className="w-8 h-8 rounded-full overflow-hidden mr-2">
                    <img 
                        src={`${process.env.REACT_APP_ASSETS_URL}/uploads/profile/${author?.avatar || 'default-avatar.png'}`} 
                        alt={author?.name || "Author"}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div>
                    <p className="text-xs font-medium">{author?.name}</p>
                    <p className="text-xs text-gray-500">
                        <ReactTimeAgo date={new Date(createdAt)} locale='en-US' timeStyle="twitter" />
                    </p>
                </div>
            </Link>
        );
    }

    // Full version
    return (
        <Link to={`/profile/${authorID}`} className="flex items-center">
            <div className="w-12 h-12 rounded-full overflow-hidden mr-3 border-2 border-gray-100">
                <img 
                    src={`${process.env.REACT_APP_ASSETS_URL}/uploads/profile/${author?.avatar || 'default-avatar.png'}`} 
                    alt={author?.name || "Author"}
                    className="w-full h-full object-cover"
                />
            </div>
            <div>
                <p className="font-medium text-gray-900">{author?.name}</p>
                <p className="text-xs text-gray-500">
                    <ReactTimeAgo date={new Date(createdAt)} locale='en-US' />
                </p>
            </div>
        </Link>
    );
};

export default PostAuthor;